<template>
  <div v-if="load" class="mb60">
    <Title/>
    <div class="row justify-content-center mt30">
      <div class="col-xl-10">
        <div class="edit edit--no-height bg-gray">
          <Tabs :tabs="tabs"
                class="tabs--big"
                @changeTab="changeTab"
          />
          <div class="d-flex justify-content-center mt30" v-if="tabs[0].active">
            <div class="edit__wrap">
              <component v-for="item in inputs"
                         :is="item.component"
                         :name="item.name"
                         :key="item.name"
                         :label="item.label"
                         v-validate="item.rules"
                         v-model="value[0][item.name]"
                         :error="errors.first(item.name)"
              />
            </div>
          </div>
          <div v-else-if="tabs[1].active">
            <div class="questions mb30 mt10">
              <div class="questions__item questions__item-checkbox"
                   v-for="item in questions"
                   @mouseleave="options = false"
                   @mouseenter="options = true"
              >
                <InputCheckbox :label="item.name"
                               :name="item.name"
                               :value="''"
                               @input="checked($event, item)"
                />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <div class="edit__wrap edit__buttons">
              <CustomButton class="btn btn--blue btn--big btn--no-transform" @click="change">
                <template v-if="tabs[0].active">
                  Добавить вопрос
                </template>
                <template v-else-if="tabs[1].active">
                  Добавить вопросы
                </template>
              </CustomButton>
              <router-link :to="{name: 'designer-generations-questions'}" class="btn btn--black btn--no-transform">Отмена</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loader v-else/>
</template>

<script>
  import Tabs from "../components/Tabs";
  import Title from "../components/Title";
  import EditInputs from "../components/edit/EditInputs";
  import CustomButton from "../components/CustomButton";
  import Loader from "../components/Loader";
  import InputCheckbox from "../components/inputs/InputCheckbox";
  import InputTextarea from "../components/inputs/InputTextarea";
  import InputText from "../components/inputs/InputText";
  export default {
    name: "QuestionNew",
    components: {InputText, InputTextarea, InputCheckbox, Loader, CustomButton, EditInputs, Title, Tabs},
    data() {
      return {
        tabs: [
          {
            title: 'Ваш вопрос',
            active: true
          },
          {
            title: 'Справочник вопросов'
          }
        ],
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Вопрос',
            rules: {
              required: true
            }
          },
          {
            component: 'InputTextarea',
            name: 'info',
            label: 'Вспомогательная информация',
            rules: {
              required: true
            }
          }
        ],
        value: [{}],
        questions: [],
        load: false
      }
    },
    methods: {
      changeTab(index) {
        for (let i = 0; i < this.tabs.length; i++) {
          this.$set(this.tabs[i], 'active', i === index);
        }
        this.value = [{}];
      },
      change() {
        let params = {};
        Object.assign(params, this.$route.params);
        for (let value of this.value) {
          value.status = 'active';
        }
        params.questions = this.value;
        this.$store.dispatch('questionsGenerations/QUESTION_GENERATIONS_NEW', params)
          .then(res => {
            if (res.ok) {
              this.$router.push({name: 'designer-generations-questions'});
            }
          });
      },
      checked(e, data) {
        if (e === 'active') {
          if (this.value[0].name === undefined) {
            this.value[0] = data;
          }
          else {
            this.value.push(data);
          }
        }
        else {
          for (let i = 0; i < this.value.length; i++) {
            if (this.value[i].name === item.name) {
              this.value.splice(i, 1);
              break;
            }
          }
        }
      },
      getData() {
        this.questions = [];
        this.load = false;
        this.$store.dispatch('questionsGenerations/QUESTIONS_GENERATIONS_FILTER', this.$route.params)
          .then(res => {
            this.questions = res.body;
            this.load = true;
          });
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.getData();
      });
    }
  }
</script>

<style scoped>

</style>